var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 39,
    viewBox: "0 0 55 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 28.6665V17.6665C12.8333 14.6289 15.2957 12.1665 18.3333 12.1665C21.3708 12.1665 23.8333 14.6289 23.8333 17.6665V28.6665M42.1666 10.3332V28.6665M42.1666 19.4998H34.8333C32.8082 19.4998 31.1666 21.1415 31.1666 23.1665C31.1666 25.1915 32.8082 26.8332 34.8333 26.8332H42.1666M12.8333 23.1665H23.8333M9.16659 1.1665H45.8333C49.8833 1.1665 53.1666 4.44975 53.1666 8.49984V30.4998C53.1666 34.5499 49.8833 37.8332 45.8333 37.8332H9.16658C5.1165 37.8332 1.83325 34.5499 1.83325 30.4998V8.49984C1.83325 4.44975 5.1165 1.1665 9.16659 1.1665Z",
    stroke: "#00CFC5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.99d6c5bea25dfb39363741f6d7fddf6c.svg";
export { ForwardRef as ReactComponent };